import requestFunctions from "../../functions/requestFunctions";

export const state = {
  REPORTS_ITEM: {},
  REPORTS_LIST: [],
  REPORTS_TABLE_DATA: [],
  REPORTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_REPORTS_ITEM: (state) => {
    return state.REPORTS_ITEM;
  },
  GET_REPORTS_LIST: (state) => {
    return state.REPORTS_LIST;
  },
  GET_REPORTS_TABLE_DATA: (state) => {
    return state.REPORTS_TABLE_DATA;
  },
  GET_REPORTS_TOTAL_ROWS: (state) => {
    return state.REPORTS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_REPORTS_ITEM(state, item) {
    state.REPORTS_ITEM = item;
  },
  UPDATE_REPORTS_LIST(state, list) {
    state.REPORTS_LIST = list.data;
    state.REPORTS_TABLE_DATA = [];
    state.REPORTS_TOTAL_ROWS = list.total;
    list = list.data;

    if(list !== null) {
      list.forEach(el => {

        let status = '';

        if(el.status === 'created'){
          status = 'Новый'
        }
        if(el.status === 'preparing'){
          status = 'Подготовка'
        }
        if(el.status === 'ready'){
          status = 'Готов'
        }
        if(el.status === 'canceled'){
          status = 'Отменен'
        }
        if(el.status === 'error'){
          status = 'Ошибка'
        }

        let user_data = '';
    
        if(el.profile_fullname !== null){
          user_data = el.profile_fullname;
        }
        
        if(el.user_phone !== null ){
          if(user_data !== ''){
            user_data = user_data + ', ';
          }
          user_data = user_data + el.user_phone;
        }

        state.REPORTS_TABLE_DATA.push({
          'id'        : el.id,
          'created_at': el.created_at,
          'uuid'      : el.uuid,
          'name'      : el.name,
          'filename'  : el.filename,
          'filepath'  : el.filepath,
          'status'    : status,
          'user_data' : user_data
        });
      });
    }
  },
}

export const actions = {

  async FETCH_REPORTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/reports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_REPORTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_REPORTS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/reports';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_REPORTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_REPORTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/reports';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_REPORTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/reports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_REPORTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/reports/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}